export default __webpack_public_path__ + "static/media/mongodb.57383267.png";